import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './GuestLanding.css';

export default function GuestLanding() {
  const [name, setName] = useState('');
  const [room, setRoom] = useState('');
  const [err, setErr] = useState('');
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    if (!name.trim() || !room.trim()) {
      setErr('Name and Room are required');
      return;
    }

    // Clear any previous errors
    setErr('');

    // Navigate to guestroom with query parameters
    navigate(`/guestroom?name=${encodeURIComponent(name)}&roomId=${encodeURIComponent(room)}`);
  };

  return (
    <div className="guestlanding-wrap">
      <div className="guestlanding-card">
        <h2>Join as Guest</h2>
        <form onSubmit={submit}>
          <input
            type="text"
            placeholder="Your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="text"
            placeholder="Room code"
            value={room}
            onChange={(e) => setRoom(e.target.value)}
          />
          <button type="submit">Join</button>
        </form>
        {err && <div className="err">{err}</div>}
      </div>
    </div>
  );
}
